<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<i class="mdi mdi-circle" [ngClass]="ngClasses"></i>
    <ng-content></ng-content> -
    <ng-container *ngIf="enabled; else notEnabled">{{'ACTIVE' | translate}}</ng-container>
    <ng-template #notEnabled>{{'INACTIVE' | translate}}</ng-template>
